import Question from './Question';

export default Question;
